// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPeriodFilterSchema {
  /** UI значение для фильтра (Н-р: За полгода) **/
  name: string;
  /** Возможные значения фильтра **/
  value: EValue;
}

export enum EValue {
  /** За всё время **/
  'AllTime' = 'allTime',
  /** За полгода **/
  'HalfYear' = 'halfYear',
  /** За год **/
  'Year' = 'year',
}
